module.exports = __webpack_public_path__ + "img/img-b11812e4.5df7b3cb.png";